// Hybec Air — collapses the "Colour" filter's ~34 near-duplicate finish
// names down to one visible swatch per generic colour family (Black,
// White, Wood/Brown, Gold/Brass, Silver/Grey), mirroring the same bucket
// logic used for the swatch backgrounds in assets/hybec-air.css. Only one
// checkbox per family stays visible; the rest are hidden (not removed) and
// kept in sync so a shopper filtering by "Black" still matches every black
// finish, not just one literal option value.
//
// The Colour filter's list is re-rendered from the server on every filter
// change (Shopify's section-rendering API replaces the DOM), so this has
// to re-run after every such update, not just once on load. A
// MutationObserver on the filters area covers that plus the "Show more"
// reveal without depending on a specific theme event name.
(function () {
  if (window.__hyFacetColorGroupsInit) return;
  window.__hyFacetColorGroupsInit = true;

  // 10 generic swatch families, most-specific rule first — the first rule
  // whose keywords ALL appear in the value wins (mirrors a Liquid
  // if/elsif chain). Keep this in sync with the facet colour rules in
  // assets/hybec-air.css (input[name='filter.v.option.color'][data-label...]).
  var RULES = [
    ['#c9a227', ['antique brass', 'matt white']],
    ['#c9a227', ['antique brass', 'transparent']],
    ['#c9a227', ['champagne gold']],
    ['#c9a227', ['rose gold', 'matt white']],
    ['#c9a227', ['rose gold']],
    ['#c9a227', ['gold matt']],
    ['#b5502e', ['red copper']],
    ['#4a4a48', ['black', 'silvery']],
    ['#2b1e16', ['black bamboo']],
    ['#2b1e16', ['black', 'darkwood']],
    ['#2b1e16', ['matt black', 'dark wood']],
    ['#2b1e16', ['matt black', 'light wood']],
    ['#2b1e16', ['matt black', 'pine wood']],
    ['#2b1e16', ['matt black', 'wooden']],
    ['#2b1e16', ['orb', 'light wood']],
    ['#2b1e16', ['orb', 'dark wood']],
    ['#2b1e16', ['orb']],
    ['#1c1c1c', ['matte black']],
    ['#1c1c1c', ['black']],
    ['#a8a8a8', ['nickel']],
    ['#a8a8a8', ['steel']],
    ['#a8a8a8', ['grey']],
    ['#e8dcc4', ['bamboo', 'white']],
    ['#e8dcc4', ['white wood grain']],
    ['#e8dcc4', ['white', 'lightwood']],
    ['#5b3a29', ['matt dark wood']],
    ['#5b3a29', ['dark wood']],
    ['#c8a874', ['light wood']],
    ['#f5f3ee', ['matt white']],
    ['#f5f3ee', ['matte white']],
    ['#f5f3ee', ['pearl white']],
    ['#f5f3ee', ['white']],
  ];

  function bucketFor(label) {
    var v = (label || '').toLowerCase();
    for (var i = 0; i < RULES.length; i++) {
      var color = RULES[i][0];
      var keywords = RULES[i][1];
      var allMatch = true;
      for (var j = 0; j < keywords.length; j++) {
        if (v.indexOf(keywords[j]) === -1) {
          allMatch = false;
          break;
        }
      }
      if (allMatch) return color;
    }
    return '#9a9a9a';
  }

  function process(list) {
    if (list.dataset.hyGrouped === 'done') return;

    var items = Array.prototype.slice.call(
      list.querySelectorAll('.facets__inputs-list-item')
    );
    var groups = {};

    items.forEach(function (item) {
      var input = item.querySelector('input[name="filter.v.option.color"]');
      if (!input) return;
      var color = bucketFor(input.dataset.label);
      if (!groups[color]) groups[color] = [];
      groups[color].push({ item: item, input: input });
    });

    Object.keys(groups).forEach(function (color) {
      var entries = groups[color];
      var rep = entries[0];

      // If a hidden duplicate came pre-checked (e.g. from a shared URL),
      // reflect that on the visible representative.
      var anyChecked = entries.some(function (e) {
        return e.input.checked;
      });
      if (anyChecked) rep.input.checked = true;

      entries.slice(1).forEach(function (e) {
        e.item.hidden = true;
        e.item.setAttribute('data-hy-swatch-duplicate', '');
      });

      if (!rep.input.dataset.hyGroupBound) {
        rep.input.dataset.hyGroupBound = 'true';
        rep.input.addEventListener('change', function () {
          entries.slice(1).forEach(function (e) {
            e.input.checked = rep.input.checked;
          });
        });
      }
    });

    list.dataset.hyGrouped = 'done';
  }

  function scan(root) {
    (root || document)
      .querySelectorAll('.facets__inputs-list[name="Colour"]')
      .forEach(process);
  }

  scan();

  var observer = new MutationObserver(function () {
    scan();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
